import React, { useEffect, useState } from "react";
import Seo from "../components/Seo";

function BudgetMate() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/api/expenses")
      .then((res) => res.json())
      .then((d) => setData(d));
  }, []);

  return (
    <div style={{ padding: "50px 20px", maxWidth: "900px", margin: "0 auto" }}>
      <Seo title="BudgetMate — App" description="Manage your daily expenses, view summaries, and track salary with BudgetMate." />
      <h1>BudgetMate – Smart Budget App</h1>
      <p>Manage your daily expenses smartly with BudgetMate!</p>

      <a
        href="https://play.google.com/store/apps/details?id=com.yourapp.package"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Get it on Google Play"
          style={{ width: "200px", marginTop: "20px" }}
        />
      </a>

      <div style={{ marginTop: "30px" }}>
        <h2>Expenses (from backend)</h2>
        {data ? (
          <ul>
            {data.expenses.map((item) => (
              <li key={item.id}>
                {item.title}: ₹{item.amount}
              </li>
            ))}
          </ul>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
}

export default BudgetMate;
